import { AuthConfig } from "./AuthConfig";
export const AUTH_CONFIG: AuthConfig = {
  audience: "https://api.cimpress.io/",
  clientId: "fHBGawIfSgkvc2edvAcx3v7KG6qi2Xia",
  coamGroupId: "2833",
  coamPrincipalUrl: "https://api.cimpress.io/auth/access-management/v1/principals",
  domain: "cimpress.auth0.com",
};
